const actions = {
  getListagem: async (context, { page, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/vendors/users`, {
      page,
      per_page,
    });

    return res;
  },

  listarUsuarios: async (context, { per_page, search, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        per_page,
        search,
        vendor_id,
      },
    });

    return response;
  },

  listarProdutos: async (context, { per_page, search, page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`products`, {
      params: {
        per_page,
        search,
        page,
      },
    });

    return response;
  },

  getCategorias: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-categories`);

    return response;
  },

  getCA: async (context, { code }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cas`, {
      params: {
        per_page: 15,
        code,
      },
    });

    return response;
  },

  getUsers: async (context, { search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        search,
      },
    });

    return response;
  },

  criarRegistro: async (
    context,
    { contract_id, fields, products, workflow_users }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`contracts/workflow/init`, {
      contract_id,
      fields,
      products,
      workflow_users,
    });

    return response;
  },

  getAcompanhamento: async (context, { id, status, produto }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/workflow/${id}`, {
      params: {
        per_page: 100,

        status,
        produto,
      },
    });

    return response;
  },

  getProdutosAcompanhamento: async (context, { id, per_page, page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/${id}/products`, {
      params: {
        perPage: per_page,
        page,
      },
    });

    return response;
  },

  aprovar: async (context, { contract_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/workflow/approve-phase`, {
      contract_id,
      products,
    });

    return response;
  },

  reprovar: async (context, { contract_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/workflow/reprove`, {
      contract_id,
      products,
    });

    return response;
  },
};

export const wf = {
  namespaced: true,
  actions,
};
